const fundTermStatus = [
  { id: 'ACTIVE', name: 'Active' },
  { id: 'INACTIVE', name: 'Inactive' }
];

export { fundTermStatus };
